/**旭日图 */
import React from 'react';
import ReactEcharts from 'echarts-for-react'  

import WidgetEchartConfig from './WidgetEchartConfig'

class WidgetEcharSunburst extends React.Component
{
    constructor(props)
    {
        super(props);

        this.state = {
            data : props.data,
            option : props.option,
            width : 0,
            height : 0
        } 

        this.onEvent = this.onEvent.bind(this);
        this.buildConfig = this.buildConfig.bind(this);

        this.updateRect = this.updateRect.bind(this);

         // 获取组件自身
         this.myRef = React.createRef();
    }

    /** event */
    onEvent(chart, event) 
    {
        if( this.props.isEvent===undefined || this.props.isEvent===false )
        {
            return ;
        }

        if( event.type==="element:mousedown" )
        {
            if( this.props.event!==undefined )
            {
                this.props.event( event, event.data.data );
            }
        } 
    }

    /** create config */
    buildConfig(option, data)
    {
        let config = {};
        if( option.theme!==undefined )
        {
            config = {...WidgetEchartConfig.theme[option.theme].sunburstConfig, ...config};
        }
        else
        {
            config = {...WidgetEchartConfig.theme["default"].sunburstConfig, ...config};
        }

        if( config.series!==undefined )
        {
            config.series['data'] = data.data;
        }

        if( config.tooltip!==undefined )
        {
            config.tooltip["formatter"] = function( params )
            {
                if( option.tooltipFormatter!==undefined )
                {
                    return option.tooltipFormatter( params );
                }
                else
                {
                    return params.name + ":" + params.value;
                }
            }
            
        }
        
        return config;
    }

    updateRect()
    {
        if( this.myRef!==undefined )
        {
            const height = this.myRef.current.echartsElement.parentElement.clientHeight;
            const width = this.myRef.current.echartsElement.parentElement.clientWidth;
            
            if (this.state.width !== width || this.state.height !== height)
            {
                this.setState({width:width, height:height});
            }
        }
    }

    componentDidMount()
    {
        this.updateRect();
    }

    componentDidUpdate()
    {
        this.updateRect();
    }

    render()
    {
        const { option, data } = this.props; 

        const { height } = this.state;
        
        let config = this.buildConfig(option, data);

        return <ReactEcharts ref={this.myRef} option={ config } lazyUpdate={true} style={{ height: height }}></ReactEcharts>;
    }
}

export default WidgetEcharSunburst;
